<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="(tab, index) in props.tabs" :key="index">{{
        tab.tab
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(tab, index) in props.tabs" :key="index">
        <GenerarComponentes :layout="tab.layout" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import GenerarComponentes from "./GenerarComponentes";
export default {
  name: "Tabs",
  props: {
    props: {
      type: Object,
      required: true,
    },
  },
  components: {
    GenerarComponentes,
  },
  data: () => ({
    tab: 0,
  }),
};
</script>
